import * as React from 'react';
import client from '../api/contentful';
import { Entry } from 'contentful';

export interface IWhistleTrack {
  name: string;
  artist: string;
  file: Entry<IFile>;
}

interface IFile {
  description: string;
  file: {
    url: string;
    contentType: string;
    details: {
      size: number;
    };
  };
}

export type WhistleTrackEntry = Array<Entry<IWhistleTrack>>;

export default class WhistleTrack {
  static data: WhistleTrackEntry;
  private static promise: Promise<WhistleTrackEntry>;

  static getData(): Promise<WhistleTrackEntry> {
    if (WhistleTrack.promise) {
      return WhistleTrack.promise;
    }

    const promise = client
      .getEntries<IWhistleTrack>({
        content_type: 'whistleTracks',
      })
      .then(data => {
        WhistleTrack.data = data.items;

        return WhistleTrack.data;
      });

    WhistleTrack.promise = promise;

    return promise;
  }
}

export interface IRenderProps {
  data: WhistleTrackEntry;
}

interface IProps {
  render:
    | ((props: IRenderProps) => React.ReactNode)
    | React.ComponentClass<IRenderProps>;
  fallback?: React.SFC | React.ComponentClass;
  [key: string]: any;
}

interface IState {
  data: WhistleTrackEntry | undefined;
}

function isComponentClass(render: any): render is React.ComponentClass {
  return undefined !== render.prototype.isReactComponent;
}

const blackList = new Set(['render', 'fallback']);

export class WhistleTrackRenderer extends React.PureComponent<IProps, IState> {
  state: IState = {
    data: undefined,
  };

  componentDidMount() {
    this.fetch();
  }

  fetch() {
    WhistleTrack.getData().then(data => this.setState({ data }));
  }

  render() {
    const extraProps = Object.keys(this.props).reduce((acc, key) => {
      if (!blackList.has(key)) {
        acc[key] = this.props[key];
      }
      return acc;
    }, {});

    if (this.state.data) {
      if (isComponentClass(this.props.render)) {
        const Render = this.props.render;
        return <Render data={this.state.data} {...extraProps} />;
      }

      return this.props.render({
        data: this.state.data,
        ...extraProps,
      });
    }

    if (this.props.fallback) {
      const Fallback = this.props.fallback;

      return <Fallback />;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/models/WhistleTrack.tsx